var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeksReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5397 38.2392V6H15.1654L10 11.258V38.1762L12.2663 35.9099L14.1607 37.8043L16.0551 35.9099L17.9496 37.8043L19.8439 35.9099L21.7384 37.8043L23.6328 35.9099L25.5272 37.8043L27.4216 35.9099L29.316 37.8043L31.2104 35.9099L33.5397 38.2392ZM31.8314 34.1148L31.2105 33.4939L29.3161 35.3883L27.4217 33.4939L25.5273 35.3883L23.6328 33.4939L21.7385 35.3883L19.844 33.4939L17.9496 35.3883L16.0552 33.4939L14.1608 35.3883C14.1608 35.3883 12.2664 33.4939 12.2664 33.4939L11.7085 34.0519V11.9567L15.882 7.70841H31.8314V34.1148Z",
    fill: "#2F2F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6141 16.9918H28.9258V15.4167H14.6141V16.9918Z",
    fill: "#2F2F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6141 20.6776H28.9258V19.1025H14.6141V20.6776Z",
    fill: "#2F2F5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6141 28.0492H22.6871V26.4741H14.6141V28.0492Z",
    fill: "#2F2F5B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7877 28.0492H28.9257V26.4741H24.7877V28.0492Z",
    fill: "#2F2F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeksReport);
export default __webpack_public_path__ + "static/media/keks_report.be541b6f.svg";
export { ForwardRef as ReactComponent };